export default __webpack_public_path__ + "static/media/email.9082177d.png";